import { ConsultationResource } from '@aorg/models/resources/Consultation/ConsultationResource';
import createConsultationRespone from '@aorg/services/api/consultations/createConsultationResponse';
import getExpertConsultation from '@aorg/services/api/consultations/getExpertConsultation';
import {
  selectExpertConsultationSelected,
  setExpertConsultationSelected,
  useAppDispatch,
  useAppSelector,
} from '@aorg/store';
import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';
import { useEffect, useRef, useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { HiOutlinePaperAirplane, HiPaperAirplane } from 'react-icons/hi2';
import { useParams } from 'react-router-dom';
import ChatAvatar from '../../../assets/chat-avatar.png';
import AorgMarkdown from '../../components/AorgMarkdown';
import UserAvatar from '../../components/UserAvatar';
import styles from './Expert.module.scss';
import AudioRecorder from './components/AudioRecorder/AudioRecorder';
import Editor from './components/MarkdownEditor/Editor';

function ExpertConsultsDetail() {
  const consult = useAppSelector(selectExpertConsultationSelected);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [audio, setAudio] = useState('');
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const [error, setError] = useState();
  const params = useParams();

  console.log(params.uuid);

  useEffect(() => {
    setLoading(true);
    getConsultDetail(params?.uuid);
  }, []);

  const getConsultDetail = async (uudi?: string) => {
    await getExpertConsultation(uudi ? uudi : consult?.uuid)
      .then(({ data }) => {
        dispatch(setExpertConsultationSelected(data.data));
        setLoading(false);
      })
      .catch((error) => {
        console.log('getExpertConsultation@Error', error);
        setLoading(false);
      });
  };

  const handleResponse = () => {
    if (!consult || isEmpty(text)) return;

    const params = {
      consultation_id: consult?.uuid,
      response: text,
    };

    setText('');

    createConsultationRespone(params)
      .then(({ data }) => {
        dispatch(
          setExpertConsultationSelected({ ...consult, response: data.data })
        );
      })
      .catch((error) => {
        if (error.response.data.message) {
          setError(error.response.data.message);

          setTimeout(() => setError(undefined), 5000);
        }
        console.log('CreateConsultationResponse@Error', error);
      });
  };

  // useEffect used to scrool to bottom
  useEffect(() => {
    scrollToBottom();
  }, [consult, loading]);

  const scrollToBottom = () => {
    if (messagesEndRef.current)
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  if (!consult || loading) return <></>;
  return (
    <div className="w-full h-screen flex-1 bg-secondary-900  text-secondary-100">
      {/* HEADER */}
      <div className={` w-full pt-10 bg-secondary-900 px-4 md:fixed`}>
        <div className="container mx-auto max-w-5xl pt-20">
          <div className=" w-full flex flex-row justify-between pb-4 border-b border-b-secondary-500/40">
            <div className="flex flex-col gap-2">
              <div className="flex flex-row gap-2 text-2xl font-bold">
                <div className="font-extrabold">Subject: </div>{' '}
                {consult.subject}
              </div>
              <div className="text-sm font-light">
                {DateTime.fromISO(consult.created_at).toFormat(
                  'dd MMM yyyy hh:mm a'
                )}
              </div>
            </div>
            {/* <div className="flex flex-row gap-2 items-center">
              <div className="text-xl font-bold">
                {consult.user.first_name} {consult.user.last_name}
              </div>
              <UserAvatar user={consult.user} />
            </div> */}
          </div>
          <div className="w-full flex flex-col my-4 gap-2">
            <div className="font-extrabold text-xl">Detail: </div>
            <div className="font-bold text-lg">{consult.details}</div>
          </div>
        </div>
      </div>

      {/* BODY */}
      <div className="flex flex-1 w-full mb-10 md:pt-80 pb-96 px-4 ">
        <div className="container mx-auto max-w-5xl">
          {consult.conversation && <TranscriptMessages consult={consult} />}

          <div className="flex flex-col gap-2 mt-4">
            {consult.response && (
              <div className="flex flex-row gap-4 justify-end items-center py-4 px-2 bg-secondary-500 rounded-md">
                <AorgMarkdown content={consult.response.response} />
                <UserAvatar user={consult.response.expert} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Input Editor content */}
      <div
        className={`w-full px-4 pt-8 pb-8 fixed bottom-0 flex flex-col justify-end ${styles.gradientOverlay}`}
      >
        <div className="flex flex-col gap-2 container mx-auto max-w-5xl">
          {error && <div className="text-red-500 px-2">{error}</div>}
          <div>
            <Editor value={text} setValue={setText} />
          </div>
          <div className="flex flex-row justify-between px-4">
            <AudioRecorder ReturnAudio={setAudio} />

            <div
              className="flex flex-row items-center justify-between gap-2 max-w-min whitespace-nowrap py-2 px-4 bg-primary-400 text-white rounded-md cursor-pointer"
              onClick={handleResponse}
            >
              <div>Send</div>
              {text.length > 0 || !isEmpty(audio) ? (
                <HiPaperAirplane className=" h-6 w-6 text-white font-black" />
              ) : (
                <HiOutlinePaperAirplane
                  className=" h-6 w-6 text-white font-black"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TranscriptMessages({ consult }: { consult: ConsultationResource }) {
  const [conversationOpen, setConversationOpen] = useState(false);

  return (
    <div className="bg-secondary-400 rounded-md">
      <div
        className="py-4 px-2 flex flex-row justify-between items-center"
        onClick={() => setConversationOpen(!conversationOpen)}
      >
        <div className="text-xl ml-4 text-white">Conversation</div>
        {!conversationOpen ? (
          <FaAngleDown className="h-6 w-6 text-white" />
        ) : (
          <FaAngleUp className="h-6 w-6 text-white" />
        )}
      </div>
      {conversationOpen &&
        consult.conversation.messages.map((item, index) => (
          <div
            className={'flex flex-col w-full px-4 pb-4'}
            key={item.question.uuid}
          >
            {/* User qestion */}
            <div className="px-5 py-6 flex flex-row gap-4 content-start items-start">
              {/* <UserAvatar
                sizeClass="w-10 h-10"
                bgClass="bg-neutral-300"
                user={consult.user}
              /> */}

              <div className="text-secondary-50 text-lg leading-8 font-medium text-start pt-1">
                {item.question.question}
              </div>
            </div>

            {/* Ai answer */}
            <div className="bg-[#1B222C] px-5 py-6 rounded-[10px]">
              <div className="flex flex-row gap-4 content-start items-start">
                <div className=" h-10 w-10 flex items-center justify-center rounded-sm bg-[#1F2937]">
                  <img src={ChatAvatar} alt="" />{' '}
                </div>
                <div className="flex flex-1 pt-[7px]">
                  <div className="text-secondary-100 text-base font-medium text-start pb-2 leading-7">
                    {item?.answer?.answer || 'Answer not found'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default ExpertConsultsDetail;
